import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import './TranscriptStudio.css'
import { NavBar } from '../Upload/'
import { HorizontalLayout, FlexContainerCentered, FlexContainer } from '../Components'
import toast, { Toaster } from 'react-hot-toast'
import { fetchMediaById, deleteMediaById, deleteTranscriptById } from '../Studio/api'
import VideoPreview from '../Components/VideoPreview'
import TranscriptCard from './TranscriptCard'
import { Container, Col } from 'react-bootstrap'
import moment from 'moment'
import _ from 'lodash'

const TranscriptStudio = () => {
    const { id } = useParams()
    const mediaType = 'transcriptStudio'

    const [isLoaded, setIsLoaded] = useState(false)
    const [originalMediaData, setOriginalData] = useState(null)
    const [mediaData, setMediaData] = useState(null)
    const [tempTags, setTempTags] = useState([])
    const [pendingASRs, setPendingASRs] = useState([])
    const [pendingICRs, setPendingICRs] = useState([])
    const [transcripts, setTranscripts] = useState([])
    const [activeSort, setActiveSort] = useState('createdAt');
    const history = useHistory()

    let mediaUrl
    if (mediaData) {
        mediaUrl = mediaData.tempResourceUrl
        mediaUrl = mediaUrl.substring(mediaUrl.indexOf('recordings/'))
        const studioUrl = process.env.REACT_APP_STUDIO_URL
        mediaUrl = `${studioUrl}/static/${mediaUrl}`
    }

    const refreshMediaData = () => {
        fetchMediaById(id).then(({ media }) => {
            setOriginalData(media)
            setMediaData(media)
            const sortedTranscripts = _.sortBy(media._transcripts, 'createdAt').reverse()
            setTranscripts(sortedTranscripts)
            setTempTags(media['tags'].map((tag) => tag.tagName) || [])
            setIsLoaded(true)
            document.title = 'Studio - ' + media.title
        })
    }

    useEffect(() => {
        refreshMediaData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleTranscriptSorting = (event) => {
        var _sort = event.target.value.split('_');
        var sort = _sort[0];
        var type = _sort[1];

        setActiveSort(sort);

        var _transcripts = [...transcripts]
        if (type == 'desc') {
            var _t = _.sortBy(_transcripts, sort).reverse();
        } else {
            var _t = _.sortBy(_transcripts, sort);
        }

        setTranscripts(_t);
    }


    return (
        <>
            <NavBar />
            <div style={{ marginTop: '7rem', overflowX: 'hidden' }}>
                <Container style={{ maxWidth: '1490px' }}>
                    <div>
                        <HorizontalLayout
                            style={{
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <div>
                                <h2>Title</h2>
                                <p>
                                    {(mediaData && mediaData.title) ||
                                        'No title'}
                                </p>
                                <h2>Description</h2>
                                <p>
                                    {(mediaData && mediaData.description) ||
                                        'No Description'}
                                </p>
                                <div>
                                    <button
                                        className="btn btn-outline-success mr-2"
                                        onClick={(_) => history.push(`/recording/${id}`)}
                                    >
                                        Go to Recording
                                    </button>
                                </div>
                            </div>
                            {mediaUrl && (
                                <VideoPreview mode="url" src={mediaUrl} />
                            )}
                        </HorizontalLayout>
                    </div>

                    <div className='mt-4'>
                        <div className='mb-4  d-flex flex-row justify-content-between'>
                            <div className="md-4">
                                <h4>Transcripts</h4>
                            </div>

                            <div className="md-8">
                                <select onChange={handleTranscriptSorting} class="custom-select">
                                    <option value="createdAt_desc" selected>Sort By Created Date (Latest)</option>
                                    <option value="createdAt_asc">Sort By Created Date (Earliest)</option>
                                    <option value="name_asc">Sort By Name (A-Z)</option>
                                    <option value="name_desc">Sort By Name (Z-A)</option>
                                </select>
                            </div>
                        </div>
                        {transcripts.map((t) => (
                            <TranscriptCard
                                key={t._id}
                                data={t}
                                refresh={() => refreshMediaData()}
                                type="transcript"
                                media={mediaData}
                            />
                        ))}
                    </div>
                </Container>
            </div>
            <Toaster
                position="bottom-right"
                reverseOrder
                toastOptions={{
                    style: {
                        borderRadius: '10px',
                        background: '#333',
                        color: '#fff',
                    },
                }}
            />
        </>
    )
}

export default TranscriptStudio